var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/File/Copy/"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.91675 1.25C6.53604 1.25 5.41675 2.36929 5.41675 3.75C4.03604 3.75 2.91675 4.86929 2.91675 6.25V16.25C2.91675 17.6307 4.03604 18.75 5.41675 18.75H12.0834C13.4641 18.75 14.5834 17.6307 14.5834 16.25C15.9641 16.25 17.0834 15.1307 17.0834 13.75V3.75C17.0834 2.36929 15.9641 1.25 14.5834 1.25H7.91675ZM14.5834 15.25C15.4118 15.25 16.0834 14.5784 16.0834 13.75V3.75C16.0834 2.92157 15.4118 2.25 14.5834 2.25H7.91675C7.08832 2.25 6.41675 2.92157 6.41675 3.75H12.0834C13.4641 3.75 14.5834 4.86929 14.5834 6.25V15.25ZM3.91675 6.25C3.91675 5.42157 4.58832 4.75 5.41675 4.75H12.0834C12.9118 4.75 13.5834 5.42157 13.5834 6.25V16.25C13.5834 17.0784 12.9118 17.75 12.0834 17.75H5.41675C4.58832 17.75 3.91675 17.0784 3.91675 16.25V6.25Z",
    fill: "#5B5C5B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.67299b09a64c832e9f2f75b393c6fcea.svg";
export { ForwardRef as ReactComponent };